var map = {
	"./404.svg": "sEM+",
	"./Merchant-audit.svg": "RO9/",
	"./Merchant-order.svg": "ZqVc",
	"./Merchant-recharge.svg": "JZzr",
	"./Merchant-transfer.svg": "8/rL",
	"./Merchant-withdraw.svg": "oi8f",
	"./QQPay.svg": "fqCe",
	"./admin.svg": "BlLF",
	"./agent-active.svg": "AgSs",
	"./agent.svg": "Liw6",
	"./bug.svg": "SVqS",
	"./channel-active.svg": "XR9P",
	"./channel.svg": "5e3z",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./company-click.svg": "yU3I",
	"./company.svg": "znPN",
	"./component.svg": "s2cW",
	"./daifuliushui.svg": "djor",
	"./dashboard.svg": "BCGP",
	"./defaulthead.svg": "n0zb",
	"./depositAmount.svg": "Kc63",
	"./documentation.svg": "zUKd",
	"./down.svg": "LHwD",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./employee-active.svg": "Wj6w",
	"./employee.svg": "Xd5t",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye.svg": "4wdf",
	"./finance-active.svg": "h2bV",
	"./finance.svg": "pTuU",
	"./form.svg": "sTIr",
	"./freeze.svg": "W659",
	"./gen.svg": "hHAc",
	"./gen2.svg": "onFy",
	"./guide 2.svg": "kA1i",
	"./guide.svg": "z74U",
	"./gx.svg": "7ffS",
	"./home-active.svg": "DXxt",
	"./home.svg": "U9Ws",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./jiaoyi.svg": "jp7U",
	"./jiaoyiliushui.svg": "pNqf",
	"./jinridaifudingdantiaoshu.svg": "010U",
	"./jinrizhifudingdantiaoshu.svg": "LcRp",
	"./jinrizhifuzongjine.svg": "CTbT",
	"./ketixianjine.svg": "THam",
	"./kj.svg": "lyp8",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./login.svg": "j/EP",
	"./logo.svg": "ZY77",
	"./logo_main.svg": "vcq3",
	"./logo_tz.svg": "gJas",
	"./menu-home-active.svg": "v3EI",
	"./menu-home.svg": "pXsZ",
	"./menu-merchant-active.svg": "ahXu",
	"./menu-merchant.svg": "RD90",
	"./menu-order-active.svg": "tW2f",
	"./menu-order.svg": "YwL1",
	"./menu-system-active.svg": "4912",
	"./menu-system.svg": "iwA/",
	"./mer.svg": "OVfm",
	"./merchant-active.svg": "Yy4m",
	"./merchant.svg": "8OX1",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./order-active.svg": "iJ2N",
	"./order.svg": "gYtG",
	"./orderNote.svg": "s6iC",
	"./paidOrder.svg": "FeVT",
	"./paidStatistics.svg": "JTw2",
	"./password.svg": "QjmH",
	"./payOrder.svg": "wMci",
	"./payStatistics.svg": "XkKW",
	"./payment.svg": "GDkK",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./peson-click.svg": "aJEx",
	"./peson.svg": "S0/n",
	"./qq.svg": "R2jY",
	"./recommend.svg": "rtce",
	"./rmb.svg": "1bsR",
	"./save.svg": "ttre",
	"./shopping.svg": "jRi0",
	"./size.svg": "Cr4N",
	"./star.svg": "60zo",
	"./statistics-active.svg": "YJNa",
	"./statistics.svg": "2O5N",
	"./success.svg": "C5yd",
	"./system-active.svg": "edU4",
	"./system.svg": "Jax1",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./transfer-active.svg": "PlzG",
	"./transfer.svg": "S35e",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./vaild.svg": "dFzy",
	"./wallet.svg": "LnY7",
	"./wangyin.svg": "JXdP",
	"./warning-new.svg": "xITT",
	"./warning.svg": "TcIt",
	"./wechat.svg": "pYJ+",
	"./withdrawAmount.svg": "zoS/",
	"./withdrawCount.svg": "h7Lq",
	"./wx.svg": "TcIh",
	"./yidongjiejine.svg": "fxUQ",
	"./zczje.svg": "DZ1e",
	"./zfb.svg": "T9eF",
	"./zfb02.svg": "1InZ",
	"./zhagnhuzongyue.svg": "lc17",
	"./zip.svg": "0DNV",
	"./zongchongzhijine.svg": "tGp2",
	"./zongji.svg": "GBFA",
	"./zy.svg": "JbDY",
	"./上海农商银行.svg": "0Zf5",
	"./上海银行.svg": "00J6",
	"./东亚银行.svg": "wd2m",
	"./中信银行.svg": "qEEM",
	"./中国银行.svg": "PsRQ",
	"./交通银行.svg": "Yj2a",
	"./光大银行.svg": "ZU5h",
	"./兴业银行.svg": "BcFp",
	"./农业银行.svg": "jWFK",
	"./北京农村商业银行.svg": "QZw5",
	"./北京银行.svg": "WD16",
	"./华夏银行.svg": "EnUl",
	"./南京银行.svg": "9DN/",
	"./宁波银行.svg": "sTax",
	"./工商银行.svg": "iwl3",
	"./平安银行.svg": "JXgA",
	"./广东发展银行.svg": "Hf3s",
	"./建设银行.svg": "fec3",
	"./招商银行.svg": "OUZ6",
	"./杭州银行.svg": "CCm/",
	"./民生银行.svg": "3psb",
	"./浙商银行.svg": "0tc8",
	"./浦东发展银行.svg": "Hq2U",
	"./深圳发展银行.svg": "At2x",
	"./渤海银行.svg": "hOsD",
	"./邮政储蓄银行.svg": "EM7c",
	"./银联快捷.svg": "wUIN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 107